import React, { useRef } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import PharmacyInvoiceReport from './PharmacyInvoiceReport';
import { generatePDF } from '../../../utils/reportUtils';
import ReportDialog from '../ReportDialog';
import { PharmacyInvoiceDetailsResponse } from '../../../pages/Billing/Pharmacy/viewPharmacyInvoice.helper';
import { PharmacyPaymentTransaction } from '../../../pages/Billing/Pharmacy/pharmacyReceiptHelper';

type Props = {
  open: boolean;
  onClose: () => void;
  data: PharmacyInvoiceDetailsResponse | null;
  isLoading?: boolean;
  error?: string | null;
  transactions?: PharmacyPaymentTransaction[];
};

const PharmacyInvoiceReportGen: React.FC<Props> = ({
  open,
  onClose,
  data,
  isLoading = false,
  error = null,
  transactions = [],
}) => {
  const reportRef = useRef<HTMLDivElement>(null);

  const handleDownloadPDF = () => {
    if (reportRef.current && data) {
      generatePDF(reportRef.current, `Pharmacy_Invoice_${data.data.invoice_info.bill_number}`);
    }
  };

  const handlePrint = () => window.print();

  return (
    <ReportDialog
      open={open}
      onClose={onClose}
      title="Pharmacy Invoice"
      onDownload={data ? handleDownloadPDF : undefined}
      onPrint={data ? handlePrint : undefined}
      downloadLabel="Download Invoice"
      printLabel="Print Invoice"
    >
      {isLoading ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <CircularProgress size={40} />
          <Typography variant="body2" sx={{ mt: 2, color: 'text.secondary' }}>
            Loading pharmacy invoice...
          </Typography>
        </Box>
      ) : error ? (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'error.main' }}>
            {error}
          </Typography>
        </Box>
      ) : data ? (
        <div ref={reportRef}>
          <PharmacyInvoiceReport invoiceData={data} transactions={transactions} />
        </div>
      ) : (
        <Box sx={{ py: 8, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            No pharmacy invoice data available.
          </Typography>
        </Box>
      )}
    </ReportDialog>
  );
};

export default PharmacyInvoiceReportGen;
